import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendCasoActivoPorIdContext,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_Json from "../../../dataJson/casoActivoContext.json";
import mock_JsonOperado from "../../../dataJson/casoActivoContextOperador.json";
import { formatearMensajeBackend } from "../../../apis/helper/helperApi";
import { TypeStatus } from "../../helpers/constantes";

interface State {
  casoActivoPorIdContext: any[];
  status: TypeStatus;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
  storageId_string: string;
  tiempoEstim_ref: string;
  tiempo_ref: string;
  serviceRequest_ref_link: string;
  operador_ref: string;
}

const initialState: State = {
  casoActivoPorIdContext: [],
  status: "idle",
  isLoading: false,
  Success: false,
  Mensaje: "",
  error: null,
  storageId_string: "",
  tiempoEstim_ref: "",
  tiempo_ref: "",
  serviceRequest_ref_link: "",
  operador_ref: "",
};
interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};
const casoActivoPorIdContextSlice = createSlice({
  name: "casoActivoPorIdContext",
  initialState,
  reducers: {
    setCasoActivoPorIdContext: (state, action: PayloadAction<any[]>) => {
      state.casoActivoPorIdContext = action.payload;
    },
    getCasoActivoPorIdContext: (state, action: PayloadAction<any[]>) => {
      state.casoActivoPorIdContext = action.payload;
    },
    setClearCasoActivoPorIdContext: (state, action: PayloadAction<any[]>) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },

    setStorageId: (state, action: PayloadAction<string>) => {
      state.storageId_string = action.payload;
    },
    setTiempoEstimRef: (state, action: PayloadAction<string>) => {
      state.tiempoEstim_ref = action.payload;
    },
    setTiempoRef: (state, action: PayloadAction<string>) => {
      state.tiempo_ref = action.payload;
    },
    setServiceRequest_ref_link: (state, action: PayloadAction<string>) => {
      state.serviceRequest_ref_link = action.payload;
    },
    setOperador_ref: (state, action: PayloadAction<string>) => {
      state.operador_ref = action.payload;
    },
  },
});
export const setBackendCasoActivoPorIdContext =
  (caseId: number, IdPerfil: number = 0): Thunk =>
  async (dispatch, getState): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      const response: AxiosResponse =
        await BackendCasoActivoPorIdContext(caseId);

      const isError =
        response.data?.Success === false ||
        (response.data?.ResultadoSolicitud !== undefined &&
          response.data?.ResultadoSolicitud !== 200);

      if (isError) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        dispatch(setSuccess(false));
      } else {
        dispatch(setCasoActivoPorIdContext(response.data.Data));
        dispatch(setIsLoading(false));
        dispatch(setStatus("succeeded"));
        dispatch(setSuccess(true));

        if (IdPerfil === 6 && response.data.Data?.[0]) {
          dispatch(
            setStorageId(response.data.Data[0].tareaOperador_ref?.storageId),
          );
          dispatch(setTiempoEstimRef(""));
          dispatch(setTiempoRef(""));
          dispatch(setServiceRequest_ref_link(""));
          dispatch(
            setOperador_ref(response.data.Data[0].tareaOperador_ref?.link),
          );
        }

        if (IdPerfil === 0 && response.data.Data?.[0]) {
          dispatch(
            setStorageId(response.data.Data[0].serviceRequest_ref?.storageId),
          );
          dispatch(setTiempoEstimRef(response.data.Data[0].tiempoEstim_ref?.link));
          dispatch(setTiempoRef(response.data.Data[0].tiempo_ref?.link));
          dispatch(
            setServiceRequest_ref_link(
              response.data.Data[0].serviceRequest_ref?.link,
            ),
          );
        }
      }

      dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setSuccess(false));
      dispatch(setStatus("failed"));

      if (error.response?.status === 401) {
        dispatch(setStatus("noAutorice"));
        dispatch(
          setMensaje(
            formatearMensajeBackend(
              "Tu sesión ha expirado. Vuelve a iniciar sesión",
            ),
          ),
        );
      } else if (error.response) {
        // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
        console.error(
          "Error de servidor:",
          error.response.status,
          error.response.data,
        );

        const errorData = error.response.data;
        const mensajeBackend = errorData?.Mensaje;
        const resultadoSolicitud = errorData?.ResultadoSolicitud;

        // Si el backend devolvió un objeto de respuesta con ResultadoSolicitud !== 200 o Success === false
        if (
          mensajeBackend &&
          (resultadoSolicitud !== 200 || errorData?.Success === false)
        ) {
          dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
        } else {
          dispatch(
            setMensaje(
              `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
            ),
          );
        }
      } else if (error.request) {
        // La solicitud fue enviada, pero no hubo respuesta
        console.error("Error de conexión:", error.message);
        dispatch(
          setMensaje(
            "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
          ),
        );
      } else {
        // Es un error de red (DNS, etc.) o un error de configuración de la solicitud
        console.error("Error de red o solicitud:", error.message);
        dispatch(
          setMensaje(
            "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
          ),
        );
      }
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
      if (getCurrentDomain() === "localhost") {
        dispatch(setIsLoading(true));

        let response: AxiosResponse = defaultResp;
        response.data = mock_Json;
        if (IdPerfil === 6) {
          response.data = mock_JsonOperado;
        }

        const mockData: any = response.data;
        const isErrorMock =
          mockData?.Success === false ||
          (mockData?.ResultadoSolicitud !== undefined &&
            mockData?.ResultadoSolicitud !== 200);

        if (isErrorMock) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          if (IdPerfil === 6 && response.data.Data?.[0]) {
            dispatch(
              setStorageId(response.data.Data[0].tareaOperador_ref?.storageId),
            );
            dispatch(setTiempoEstimRef(""));
            dispatch(setTiempoRef(""));
            dispatch(setServiceRequest_ref_link(""));
            dispatch(
              setOperador_ref(response.data.Data[0].tareaOperador_ref?.link),
            );
          }
          if (IdPerfil === 0 && response.data.Data?.[0]) {
            dispatch(setCasoActivoPorIdContext(response.data.Data));
            dispatch(
              setServiceRequest_ref_link(
                response.data.Data[0].serviceRequest_ref?.link,
              ),
            );

            dispatch(
              setStorageId(response.data.Data[0].serviceRequest_ref?.storageId),
            );
            dispatch(
              setTiempoEstimRef(response.data.Data[0].tiempoEstim_ref?.link),
            );
            dispatch(setTiempoRef(response.data.Data[0].tiempo_ref?.link));
            dispatch(
              setOperador_ref(response.data.Data[0].tareaOperador_ref?.link),
            );
          }
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

        const mock401 = await import("../../../dataJson/401.json");
        if (mock401.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        }
      }
    }
  };

export const setBackendClearCasoActivoPorIdContext =
  (): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      let response: AxiosResponse = defaultResp;
      dispatch(setCasoActivoPorIdContext([]));
      dispatch(setServiceRequest_ref_link(""));
      dispatch(setStorageId(""));
      dispatch(setTiempoEstimRef(""));
      dispatch(setTiempoRef(""));
      dispatch(setOperador_ref(""));
      dispatch(setIsLoading(false));
      dispatch(setStatus("idle"));
      dispatch(setSuccess(false));
      dispatch(setMensaje(""));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const {
  setOperador_ref,
  setCasoActivoPorIdContext,
  getCasoActivoPorIdContext,
  setClearCasoActivoPorIdContext,
  setIsLoading,
  setStatus,
  setResult,
  setSuccess,
  setMensaje,
  setError,
  setStorageId,
  setTiempoEstimRef,
  setTiempoRef,
  setServiceRequest_ref_link,
} = casoActivoPorIdContextSlice.actions;

export default casoActivoPorIdContextSlice.reducer;
